export default __webpack_public_path__ + "static/gearsEsports-8ca3db48a6bf6caf4b28f25225aa0f71.jpg";